import aboutShape from '#/assets/home/about-children-1.webp'
import iconMuslim from '#/assets/icon-muslim.png'
import iconQuran from '#/assets/icon-quran.png'

export const ABOUT_CONTENT = {
  eyebrow: 'Where your Quran journey begins',
  title: 'Welcome to ',
  highlight: "Wa'allamah Institute",
  paragraphs: [
    "At Wa'allamah Institute, we believe that every person deserves the opportunity to learn the Quran in a way that is clear, personal, and inspiring",
    'We bring together dedicated Quran teachers and learners from around the world through a flexible online learning experience designed for non-Arabic speakers, beginners, children, and anyone seeking to improve their relationship with the Quran.',
  ],
  buttonLabel: 'Read More',
}

export const ABOUT_MEDIA = {
  image: aboutShape,
  imageAlt: 'Children learning the Holy Quran at Waallamah Academy',
}

export const ABOUT_HIGHLIGHTS = [
  {
    title: 'Our Vision',
    description:
      'To become a trusted global Quran learning community where everyone can build a lifelong connection with the Book of Allah.',
    icon: iconMuslim,
    iconAlt: 'Vision icon',
  },
  {
    title: 'Our Mission',
    description:
      'To make Quran learning accessible, engaging, and personalized through qualified teachers, structured programs, and a supportive learning environment.*',
    icon: iconQuran,
    iconAlt: 'Mission icon',
  },
]
